<template>
  <button class="title-card" :class="{ selected }" @click="$emit('select', variant.variant_id)">
    <div class="select-indicator"></div>
    <div class="title-card-top">
      <span class="badge" :class="badgeClass">{{ variant.label || 'Option' }}</span>
      <span v-if="variant.why" class="title-card-tagline">{{ variant.why }}</span>
    </div>
    <div class="title-card-text">{{ variant.seo_title }}</div>
    <div class="title-card-checks">
      <span class="check-item" :class="{ warn: !v.primary_keyword_in_title }">
        <span class="ico">{{ v.primary_keyword_in_title ? '✓' : '!' }}</span> Primary keyword
      </span>
      <span class="check-item" :class="{ warn: v.title_length_status !== 'good' }">
        <span class="ico">{{ v.title_length_status === 'good' ? '✓' : '!' }}</span> {{ lengthLabel }}
      </span>
      <span class="check-item" :class="{ warn: v.banned_words_found && v.banned_words_found.length }">
        <span class="ico">{{ (v.banned_words_found && v.banned_words_found.length) ? '!' : '✓' }}</span> No banned words
      </span>
    </div>
  </button>
</template>

<script>
export default {
  name: "AiwV2TitleVariantCard",
  props: {
    variant: { type: Object, required: true },
    selected: { type: Boolean, default: false },
  },
  computed: {
    v() {
      return this.variant.validation || {};
    },
    badgeClass() {
      const map = { recommended: "rec", editorial: "editorial", seo_focused: "seo", concise: "concise" };
      return map[this.variant.style] || "rec";
    },
    lengthLabel() {
      const s = this.v.title_length_status;
      if (s === "short") return "A bit short";
      if (s === "long") return "A bit long";
      return "Good length";
    },
  },
};
</script>

<style scoped>
.title-card {
  width: 100%; text-align: left; font-family: "Mulish", system-ui, sans-serif;
  background: #fff;
  border: 1.5px solid var(--border, #e4e4e4);
  border-radius: var(--r-lg, 10px);
  padding: 18px 20px;
  margin-bottom: 8px;
  transition: all .15s;
  position: relative;
  cursor: pointer;
}
.title-card:hover { border-color: var(--border-strong, #ccc); }
.title-card.selected { border-color: var(--pop-orange, #ff5700); background: linear-gradient(180deg, var(--pop-orange-soft, #ffeddd) 0%, #fff 80%); }
.title-card-top { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; }
.badge {
  font-size: 9px; font-weight: 700; letter-spacing: .06em;
  text-transform: uppercase; padding: 3px 7px; border-radius: 3px;
}
.badge.rec { background: var(--pop-orange, #ff5700); color: #fff; }
.badge.editorial { background: var(--pop-purple-soft, #e3eeef); color: var(--pop-purple, #014751); }
.badge.seo { background: var(--pop-blue-soft, #c7ddff); color: var(--pop-blue, #316bff); }
.badge.concise { background: var(--pop-green-soft, #d6fbee); color: var(--pop-green, #25a97a); }
.title-card-tagline { font-size: 11.5px; color: var(--text-3, #6b7b7e); font-weight: 500; }
.title-card-text { font-size: 16px; line-height: 1.35; color: var(--text, #052e33); margin: 4px 0 10px; font-weight: 600; }
.title-card-checks { display: flex; flex-wrap: wrap; gap: 10px; font-size: 11.5px; color: var(--text-3, #6b7b7e); }
.check-item { display: flex; align-items: center; gap: 4px; }
.check-item .ico { color: var(--pop-green, #25a97a); font-weight: 700; }
.check-item.warn .ico { color: var(--pop-amber, #aa993b); }
.select-indicator {
  position: absolute; top: 18px; right: 18px;
  width: 20px; height: 20px; border-radius: 50%;
  border: 1.5px solid var(--border-strong, #ccc); background: #fff;
}
.title-card.selected .select-indicator { background: var(--pop-orange, #ff5700); border-color: var(--pop-orange, #ff5700); }
.title-card.selected .select-indicator::after {
  content: "✓"; color: #fff; font-size: 11px; font-weight: 700;
  display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;
}
</style>
